export default __webpack_public_path__ + "static/media/Deacon's Harness of the Eighteen Pits.ccbe87c2.jpg";